import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../components/shared";
import { toast } from 'react-toastify';
import { logOutClientCleanUp } from "../../utils/Utilities";
import { logoutUser } from '../../redux/slice/userSlice'; // Import the logoutUser action
import { useLocation } from 'react-router-dom';


const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showErrorToast = (message) => toast.error(message);
  const location = useLocation();
  // Logout logic
  const handleLogout = async (logoutType) => {
    try {
      localStorage.removeItem('postLoginRedirect');
      await logOutClientCleanUp(logoutType);
    } catch (error) {
      console.error("Error during logout:", error);
      showErrorToast("An error occurred during logout.");
    }
    finally {
      dispatch(logoutUser());
      navigate('/auth/login');
    }
  };

  useEffect(() => {
    let logoutType = new URLSearchParams(location.search).get('logoutType');
    if (!logoutType || logoutType.trim() === '') {
      logoutType = 'full-logout';
    }

    handleLogout(logoutType);
  }, [dispatch, navigate, location]);

  return (
    <>
      <Navbar />
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <Loading />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Logout;
